import cognizant from '../companies/cognizant.svg'
import nx from '../companies/Nx.png'
import fiverr from '../companies/Fiverr.webp'
import appinventiv from '../companies/Appinventiv.jpg'
import akgec from '../companies/akgec.png'

export const experiences = [
  {
    title: "Senior Software Engineer",
    company_name: "Appinventiv",
    icon: appinventiv,
    iconBg: "#ffffff",
    date: "August-2024 - Current",
    points: ["First senior role, leading a team of creative minds with a constant learning"],
  },
  {
    title: "Software Development Engineer-I",
    company_name: "Nx block trades",
    icon: nx,
    iconBg: "#ffffff",
    date: "January 2024 - August 2024",
    points: ["Collaborated with brilliant minds to develop a high-frequency trading platform for in-house traders"],
  },
  {
    title: "Pixel Maven",
    company_name: "Fiverr",
    icon: fiverr,
    iconBg: "#ffffff",
    date: "",
    points: ["Fueling creativity with coffee, crafting sleek web designs, and living the freelance dream—one project at a time"],
  },
  {
    title: "Software Developer",
    company_name: "Cognizant",
    icon: cognizant,
    iconBg: "#ffffff",
    date: "September 2021 - December 2023",
    points: ["Developed and delivered innovative web solutions tailored to meet the needs of both internal teams and external organizations"],
  },

  {
    title: "Grad student",
    company_name: "AKGEC",
    icon: akgec,
    iconBg: "#ffffff",
    date: "August 2017 - July 2021",
    points: ["Four years of learning, connecting, innovating, and shaping new possibilities, paving path for the future"],
  },
];
    
